module.exports = __webpack_public_path__ + "static/media/female.356528de.svg";